import React, { useEffect } from 'react';
import gravityGlobalStyles from '../../shared/styles/gravity-global.css?useable';

export function GravityProvider({ children }: React.PropsWithChildren) {
  useEffect(() => {
    gravityGlobalStyles.use();

    return () => {
      gravityGlobalStyles.unuse();
    };
  }, []);

  return <div className="gv-activated gv-h-full">{children}</div>;
}
